<template lang="pug">
  v-app#app(v-cloak, :light="isLight", :dark="isDark" :class="[applicationClasses, $i18n.locale]")
    v-content
      v-container#app-contents(fluid grid-list-sm)
        router-view

</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'app-layout-simple',
  data () {
    return {}
  },
  computed: {
    ...mapGetters('common/theme', ['isDark', 'isLight']),
    applicationClasses () {
      const meta = this.$route.meta
      if (!meta) {
        return ''
      }
      const clazz = meta.applicationClasses
      if (!clazz) {
        return ''
      }
      return clazz.join(' ')
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/layouts/Simple.vue